import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';
import { TextField } from 'shared/react-admin/Fields';

export const StyledContainer = styled(Box)({
  marginBottom: '8px',
  display: 'flex',
  alignItems: 'center',
});

export const StyledFieldsContainer = styled(Box)({
  display: 'flex',
  gap: '4px 16px',
  flexWrap: 'wrap',
});

export const StyledDescriptionTextField = styled(TextField)({
  wordBreak: 'break-all',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  maxWidth: '200px',
  textOverflow: 'ellipsis',
});

export const StyledDescriptionContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'nowrap',
  textWrap: 'nowrap',
});
